import { CartData, OptionalAssets, ProductType } from '@monorepo/types';
import { CartContentProgram } from './cart-content-program';

export const CartContent = ({
  selectedAsset,
  cartData,
}: {
  selectedAsset: OptionalAssets;
  cartData: CartData;
}) => {
  const { cart, products, currencies, project } = cartData;

  if (!cart || !products || !currencies || !project) {
    return null;
  }

  const assetData = cart[selectedAsset];

  if (!assetData || !assetData.items || assetData.items.length === 0) {
    return null;
  }

  const programsInCart = assetData.items.filter(
    (item) => item.productType === ProductType.Program,
  );

  const allPrograms = products?.programs || [];
  const allCurrencies = currencies;

  const currencyInCart = cart.currency;
  const originalPrice = assetData.originalPrice;

  if (programsInCart.length === 0) {
    return null;
  }

  return (
    <CartContentProgram
      allPrograms={allPrograms}
      allCurrencies={allCurrencies}
      programsInCart={programsInCart}
      currencyInCart={currencyInCart}
      originalPrice={originalPrice}
      project={project}
    />
  );
};
